import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  ApiURL = environment.ApiURL + '/admin';
  public headers_token: HttpHeaders;

  constructor(private http: HttpClient) {
    this.headers_token = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + localStorage.getItem('token')
    });
  }

  getAllCategories(): Observable<any> {
    return this.http.get(this.ApiURL + '/ProductCategory', { headers: this.headers_token });
  }

  deleteCategory(Id: any): Observable<any> {
    return this.http.delete(this.ApiURL + '/ProductCategory/' + Id, { headers: this.headers_token });
  }

  getAllCategoriesbyid(id: any): Observable<any> {
    return this.http.get(this.ApiURL + '/ProductCategory/' + id, { headers: this.headers_token });
  }

  updateproductcate(data: any): Observable<any> {
    // const body = JSON.stringify(data);
    return this.http.put(this.ApiURL + '/ProductCategory', data, { headers: this.headers_token });
  }

  addcategory(data: any): Observable<any> {
    return this.http.post(this.ApiURL + '/ProductCategory', data, { headers: this.headers_token });
  }


}
